import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import countries from '../information/countryNames.json'
const SERVER = `https://volunteer-server.onrender.com`
//const SERVER = `http://localhost:8800`
const Register = () => {
    const [category, setCategory] = useState("u");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [selectValue,setValue] = useState('')
    const [phone_number, setPhone] = useState("");
    const { register, handleSubmit } = useForm();
    const navigate = useNavigate();

    const signUp = () => {
        
        fetch(`${SERVER}/api/auth/register`, {
            method: "POST",
            body: JSON.stringify({
                email,
                password,
                category
            }),
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((res) => res.json())
        .then((data) => {
            if (data.err) {
                alert(data.err);
            } else {
                alert(data.message);
                navigate("/login");
            }
        })
        .catch((err) => console.error(err));
    };

    const onSubmit = async (data) => {
        const formData = new FormData();
        formData.append("file", data.file[0]);
        formData.append("email",email)
        formData.append("firstName",firstName)
        formData.append("lastName",lastName)
        formData.append("phone_number",phone_number)
        formData.append("password",password)
        formData.append("category",category)
        formData.append("country",selectValue)
        
        const res = await fetch(`${SERVER}/api/register/temp`, {
            method: "POST",
            body: formData,
        }).then((res) => res.json());
        console.log(res)
        alert(JSON.stringify(`${res.message}, status: ${res.status}`));
        navigate("/login");
    };

    const handleSubmitt = (e) => {
        e.preventDefault();

        signUp();
        
        setEmail("");
        setCategory("");
        setPassword("");
    };

const renderForm = 
    <>
<label htmlFor='username'>Категорія</label>
                <Form>
       
            <div key={`default-'radio'`} className="mb-3">
            <Form.Check
           
                value="u"
                label="КОРИСТУВАЧ"
                name="group1"
                type="radio"
                id={`reverse-radio-1`}
                onChange={(e) => setCategory(e.target.value)}
            />
            <Form.Check
                value="v"
                label="ВОЛОНТЕР"
                name="group1"
                type="radio"
                id={`reverse-radio-2`}
                onChange={(e) => setCategory(e.target.value)}
            />
            </div>
       
        </Form>

        <Row className="mb-3">
            <Form.Group as={Col} controlId="formGridEmail">
            <Form.Label>Пошта</Form.Label>
            <Form.Control type="email" placeholder="Введіть пошту" 
            {...register("email")}
             required
             value={email}
             onChange={(e) => setEmail(e.target.value)}
            />
            </Form.Group>

            <Form.Group as={Col} controlId="formGridPassword">
            <Form.Label>Пароль</Form.Label>
            <Form.Control type="password" placeholder="Пароль" 
            {...register("password")}
             required
             value={password}
             onChange={(e) => setPassword(e.target.value)}
            />
            </Form.Group>
        </Row>


    {category=="v" ? 
        <>
        <Form>
        <Row>
            <Col>
            <Form.Label>Ім'я</Form.Label>
            <Form.Control placeholder="Ім'я" 
            {...register("firstName")}
             required
             value={firstName}
             onChange={(e) => setFirstName(e.target.value)}/>
            </Col>
            <Col>
            <Form.Label>Прізвище</Form.Label>
            <Form.Control placeholder="Прізвище"  
            {...register("lastName")}
            required
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}/>
            </Col>
        </Row>
        </Form>
    
        <Form>
        <Row>
            <Col>
            <Form.Label>Номер телефону</Form.Label>
            <Form.Control placeholder="Номер телефону" 
            {...register("phone_number")}
              required
              value={phone_number}
              onChange={(e) => setPhone(e.target.value)}/>
            </Col>
            <Col>

            <Form.Group as={Col} controlId="formGridState">
                <Form.Label>Країна</Form.Label>
                <Form.Select defaultValue="Choose..." 
                {...register("country")}
                value={selectValue} 
                onChange={(e) => setValue(e.target.value)} 
                >
                <option>Оберіть країну</option>
                
                { countries.map((el)=>(
            <option value={el}>{el}</option> 
                )
                    
                )}
                </Form.Select>
                </Form.Group>
           
            </Col>
        </Row>
        </Form>
       
    
    <label class="form-label" for="customFile">Підтверджуюче фото волонтера</label>
  <input type="file" {...register("file")} class="form-control" id="customFile" name="file"   />  
 
  
        </>
    :null}
    <button className='registerBtn' type="submit" style={{marginTop:'2%'}}>ЗАРЕЄСТРУВАТИСЬ</button>
    <p style={{color:'white'}}>
        Маєте обліковий запис? <Link to='/login' style={{textDecoration:'none',color:"black"}}>Увійти</Link>
    </p>
    </>

    return (
        <main className='register'>
            <h1 className='registerTitle'>Створити обліковий запис</h1>
            { category=="u" ? <form  onSubmit= {handleSubmitt}> {renderForm} </form>: <form  onSubmit={handleSubmit(onSubmit)}> {renderForm} </form>}
            <Link to='/' style={{textDecoration:'none',color:"white"}}>НА ГОЛОВНУ</Link>
        </main>
    );
};

export default Register;